import { Injectable } from '@angular/core';
import { LoginResponseInterface } from '../models/login-response.interface';
import { ConstsHelper } from '../../../helpers/consts.helper';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { DeleteToken } from '../store/actions/login.actions';
import { DeleteCustomer } from '../../account/store/actions/customer.actions';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';
import { CryptService } from '../../shared/services/crypt.service';

@Injectable({
  providedIn: 'root'
})
export class TokenLocalStorageService implements CanActivate {

  environment = environment;

  constructor(
      private cookieService: CookieService,
      private cryptService: CryptService,
      private router: Router,
      private store: Store<any>
  ) {}

  /**
   * Get token information
   */
  getToken(): LoginResponseInterface {
    if (this.cookieService.get(ConstsHelper.COOKIE_CUSTOMER_TOKEN)) {
      return JSON.parse(this.cryptService.decrypt(this.cookieService.get(ConstsHelper.COOKIE_CUSTOMER_TOKEN)));
    }
    return null;
  }

  /**
   * Save token information
   */
  save(data: LoginResponseInterface, withRedirection: boolean): void {
    const cookieValue = '"{\\"name\\":\\"' + environment.data.brand + '_ec\\",\\"path\\":\\"/\\",\\"session\\":\\"' + data.session + '\\",\\"boutique_config\\":{\\"filters\\":{},\\"activ_cat\\":{}}}"';
    this.cookieService.set(environment.data.brand + '_ec', cookieValue, 5, '/', 'www' + environment.data.cookiesDomain, false, 'Strict');
    this.cookieService.set(environment.data.brand + '_ec', cookieValue, 5, '/',  environment.data.cookiesDomain, false, 'Strict');
    this.cookieService.set(ConstsHelper.COOKIE_CUSTOMER_TOKEN, this.cryptService.encrypt(JSON.stringify(data)), 5, '/',  environment.data.cookiesDomain, false, 'Strict');

    if (withRedirection) {
      // any callback url from /connexion page
      if (localStorage.getItem(ConstsHelper.LOCAL_STORAGE_CONNEXION_CALLBACK_URL)) {
        setTimeout(function() {
          this.router.navigate(
            [
              JSON.parse(
              localStorage.getItem(ConstsHelper.LOCAL_STORAGE_CONNEXION_CALLBACK_URL)).url
            ]);
        }.bind(this), 3000);
      } else if (localStorage.getItem(ConstsHelper.LOCAL_STORAGE_CALLBACK)) {
        setTimeout(function() { this.router.navigate(['/dimelo']); }.bind(this), 3000);
      } else {
        this.router.navigate(['/lignes']);
      }
    }
  }

  /**
   * this is used to clear anything that needs to be removed
   */
  clear(): void {
    this.cookieService.delete(ConstsHelper.COOKIE_CUSTOMER_TOKEN, '/', environment.data.cookiesDomain);
    localStorage.removeItem(ConstsHelper.LOCAL_STORAGE_CUSTOMER);
    localStorage.removeItem(ConstsHelper.LOCAL_STORAGE_ADMIN_PRO_FEET_TOKEN);
  }

  /**
   * @param route
   * @param state
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (state.url.includes('procedure=')) {
      const splitUrl = state.url.split('procedure=');
      if (splitUrl.length > 1) {
        localStorage.setItem(ConstsHelper.LOCAL_STORAGE_PROCEDURE_TO_OPEN, splitUrl[1]);
        return this.checkToken();
      } else {
        return this.checkToken();
      }
    } else {
      return this.checkToken();
    }
  }

  /**
   * Check token expiration
   */
  private checkToken() {
    if (this.getToken() != null) {
      const today = new Date();
      const day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate();
      // check token expiration
      if (parseInt(this.getToken().expiration, 10) >= parseInt(today.getUTCFullYear() + '' + (today.getMonth() + 1 ) + '' + day, 10)) {
        return true;
      }
    }
    this.store.dispatch(new DeleteCustomer());
    this.store.dispatch(new DeleteToken());
    this.router.navigate(['/connexion']);
    return false;
  }
}
